import * as React from "react";
import ToggleMenu from "../../ui/taste/list/toggle_menu";
import { ITag } from "../../ui/taste/list/index";

interface IOuterProps {
  left?: string;
  title?: string;
  right?: string;
  onLeftClick?: () => void;
  onRightClick: () => void;
  onSortRandClick: () => void;
  onSortOrderClick: () => void;
  onSortPriceClick: () => void;
  rightNode?: React.ReactNode;
  leftIcon?: string;
  isOpen: boolean;
  paramSort: string | null;
  tag: ITag[];
  tasteNum: number;
  changeCheck: (name: string) => void;
  getKeywordList: () => void;
}

type AllProps = IOuterProps;

const NavigationTL = (props: AllProps) => {
  const {
    title,
    left,
    right,
    onLeftClick,
    onRightClick,
    onSortRandClick,
    onSortOrderClick,
    onSortPriceClick,
    rightNode,
    leftIcon,
    isOpen,
    paramSort,
    tag,
    tasteNum,
    changeCheck,
    getKeywordList,
  } = props;

  return (
    <React.Fragment>
      <div
        className="c-nav_bar--light navigation-header"
        style={isOpen ? { overflow: "visible" } : { overflow: "hidden" }}
      >
        {/* left */}
        <div className="c-nav_bar-left">
          {left || leftIcon ? (
            <div className="c-button" onClick={onLeftClick}>
              {left ? (
                <span
                  className="c-button-strings"
                  style={{ padding: "7px 8px" }}
                >
                  {left}
                </span>
              ) : (
                <i className="material-icons">{leftIcon}</i>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* title */}
        <div className="c-nav_bar-center">
          {title ? <span className="c-button-strings">{title}</span> : <></>}
        </div>
        {/* right */}
        <div className="c-nav_bar-right">
          <div className="c-button-group">
            <span className="c-button-group-label">並び替え</span>
            <div
              onClick={onSortRandClick}
              className={
                paramSort == null ? "c-button active" : "c-button inActive"
              }
            >
              {paramSort == null ? (
                <span className="c-button-strings active">ランダム</span>
              ) : (
                <span className="c-button-strings">ランダム</span>
              )}
            </div>
            <div
              className={
                paramSort == "order" ? "c-button active" : "c-button inActive"
              }
              onClick={onSortOrderClick}
            >
              {paramSort == "order" ? (
                <span className="c-button-strings">最新</span>
              ) : (
                <span className="c-button-strings">最新</span>
              )}
            </div>
            {paramSort === "price" ? (
              <div className="c-button active" onClick={onSortPriceClick}>
                <span className="c-button-strings">グレード</span>
                <span className="material-icons">keyboard_arrow_up</span>
              </div>
            ) : paramSort === "price_desc" ? (
              <div className="c-button active" onClick={onSortPriceClick}>
                <span className="c-button-strings">グレード</span>
                <span className="material-icons">keyboard_arrow_down</span>
              </div>
            ) : (
              <div className="c-button inActive" onClick={onSortPriceClick}>
                <span className="c-button-strings">グレード</span>
                <span className="material-icons">keyboard_arrow_up</span>
              </div>
            )}
            {right ? (
              isOpen ? (
                <div
                  className={
                    tag.filter((element) => element.ischecked).length > 0
                      ? "c-button active"
                      : "c-button inActive"
                  }
                  onClick={onRightClick}
                >
                  <span className="c-button-strings">{right}</span>
                  <span className="material-icons">filter_list</span>
                </div>
              ) : (
                <div
                  className={
                    tag.filter((element) => element.ischecked).length > 0
                      ? "c-button active"
                      : "c-button inActive"
                  }
                  onClick={onRightClick}
                >
                  <span className="c-button-strings">{right}</span>
                  <span className="material-icons">filter_list</span>
                </div>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
        {rightNode}
        <div style={isOpen ? { display: "" } : { display: "none" }}>
          <div
            style={{
              position: "absolute",
              backgroundColor: "white",
              padding: "10px",
              borderBottomStyle: "inset",
            }}
          >
            <ToggleMenu
              tag={tag}
              tasteNum={tasteNum}
              isOpen={isOpen}
              changeCheck={changeCheck}
              changeToggleMenu={onRightClick}
              getKeywordList={getKeywordList}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default NavigationTL;
